<template>
  <div>
    <!--聊天记录  -->
    <div>
      <baseBreadcrumb :page="$t('message.chatHistory')" :menu="$t('message.operationAndMaintenance')" />
      <div class="body">
        <div class="tabs">
          <div class="item" :class="{ chat: chat == 'R' }" @click="hanl('R')">
            <img src="@/assets/icon/Rakuchat.png" alt="">RAKUCHAT
          </div>
          <div class="item" :class="{ chat: chat == 'W' }" @click="hanl('W')"><img src="@/assets/icon/chatword.png"
              alt="">
            CHATWORK</div>
        </div>
      </div>
      <!--CHATWORK  -->
      <CWchatHistory v-show="chat == 'W'" />
      <!-- RCchatHistory -->
      <RCchatHistory v-show="chat == 'R'" />
    </div>

  </div>
</template>
<script>
import CWchatHistory from './components/CWchatHistory'
import RCchatHistory from './components/RCchatHistory'
export default {
  components: {
    CWchatHistory, RCchatHistory
  },
  data() {
    return {
      chat: 'R',
    };
  },
  methods: {
    hanl(type) {
      this.chat = type
    },
  }
}
</script>
<style lang='scss' scoped>
.tabs {
  display: flex;

  .item {
    font-size: 25px;
    margin-right: 50px;
    padding: 10px;
    border-radius: 8px;
    cursor: pointer;

    img {
      width: 40px;
      vertical-align: middle;

    }
  }

  .chat {
    background-color: #b4272d;
    color: #fff;
    font-weight: bold;
  }
}
</style>